import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import "moment/locale/zh-cn";
import React from "react";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import moment from "moment";
import Cookie from "js-cookie";
import App from "./App";
import locales from "@/locales/index";
import { getLanguage } from "@/utils/utils";
import "@/App.scss";

class Root extends React.Component {
    state = {
        languageName: localStorage.getItem("languageName") || "en",
    };

    // 切换当前语言
    handleChangeCurrentLang = (languageName) => {
        localStorage.setItem("languageName", languageName);
        window.location.reload();
    };

    render () {
        // 选中的语言
        const language = locales[this.state.languageName];

        return (
            <ConfigProvider locale={language}>
                <App
                    language={language}
                    languageName={language.value}
                    getLanguage={getLanguage}
                    languageChange={this.handleChangeCurrentLang}
                />
            </ConfigProvider>
        );
    }
}

ReactDOM.render(<Root />, document.getElementById("root"));
